import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import AlertBox from "../../components/Messages";
import { useConfirmEmailQuery } from "../../services/API/titanApi";
import BasePage from "../BasePage/BasePage";
import "./VerifySuccess.scss";

function VerifySuccess() {
  const { i18n, t } = useTranslation("translation");
  const navigate = useNavigate();

  const [queryParameter, setQueryParameter] = useSearchParams();
  const rid = queryParameter.get("rid");
  const { error, isError, isSuccess } = useConfirmEmailQuery(rid);

  return (
    <BasePage size={5}>
      <div className="p-md-5 mx-md-4">
        <div className="verify-spacer"></div>
        {!error?.data?.error && (
          <h1 className="my-5 pb-1 login-headline">{t("verify.successText")}</h1>
        )}

        {error?.data?.error && <AlertBox show={isError} message={t("verify.invalidId")} />}

        {/*        
        <br />
         <div className="pt-1 my-5 pb-1">
          <button
            className="login-button"
            type="button"
            onClick={() => navigate("/")}
          >
            <div className="verticallyAligned">
              <div>{t("login.login")}</div>
              <div style={{ marginLeft: "25px" }}>
                <FontAwesomeIcon color="yellow" icon={faChevronRight} />
              </div>
            </div>
          </button>
        </div>
    <br />
 */}
      </div>
    </BasePage>
  );
}

export default VerifySuccess;
